var map = {
	"./apple-touch-icon-retina.png": 1709,
	"./apple-touch-icon.png": 1710,
	"./chatdesk-logo.png": 1711,
	"./chatdesk_video_thumbnail.png": 736,
	"./check-mark.png": 1712,
	"./delighted.png": 1713,
	"./facebook.png": 695,
	"./favicon16.png": 1714,
	"./favicon32.png": 1715,
	"./favicon48.png": 1716,
	"./front.png": 698,
	"./gladly.png": 1717,
	"./gorgias.png": 1718,
	"./helpscout.png": 699,
	"./icon_business.png": 240,
	"./icon_gladly.png": 737,
	"./icon_gorgias.png": 738,
	"./icon_lock.png": 1719,
	"./icon_reamaze.png": 739,
	"./icon_shopify.png": 740,
	"./icon_status_green.png": 741,
	"./icon_status_red.png": 742,
	"./icon_status_yellow.png": 743,
	"./icon_twitter.png": 1720,
	"./icons/icon_thumbs_up.png": 744,
	"./instagram.png": 696,
	"./kustomer.png": 745,
	"./live_agent.png": 1721,
	"./logos/logo_dixa.png": 511,
	"./logos/logo_reamaze.png": 338,
	"./logos/logo_tiktok_shop.png": 512,
	"./no-image-rect.png": 1722,
	"./no-image.png": 1723,
	"./profile_pic_grace.png": 1724,
	"./profile_pic_tara.png": 746,
	"./reamaze.png": 1725,
	"./salesforce_service_cloud.png": 1726,
	"./shopify.png": 1727,
	"./skin/database_add.png": 1728,
	"./skin/database_delete.png": 1729,
	"./skin/database_edit.png": 1730,
	"./skin/database_save.png": 1731,
	"./skin/database_table.png": 1732,
	"./skin/exclamation.png": 1733,
	"./skin/house.png": 1734,
	"./skin/information.png": 1735,
	"./stamped.png": 1736,
	"./tick.png": 1737,
	"./tiktok.png": 700,
	"./twitter.png": 694,
	"./yotpo.png": 1738,
	"./zendesk-chat.png": 747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1708;